import React from 'react';

export const removeAccount = {
  id: 'settings-remove-account',
  title: 'Remove Your Account',
  description: 'How to permanently delete your account and all associated data.',
  category: 'settings',
  lastUpdated: '2025-06-29',
  tags: ['account', 'delete', 'privacy'],
  content: () => (
    <div>
      <div className="space-y-6">
        <p className="text-muted-foreground leading-relaxed">
          If you need to permanently delete your account and all associated data, I'll help you with that process.
        </p>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Account Deletion Process</h2>
          <p className="text-muted-foreground leading-relaxed mb-3">
            To request account deletion:
          </p>
          <ol className="list-decimal list-inside text-muted-foreground space-y-2 ml-4">
            <li>Send an email to <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a></li>
            <li>Use the same email address you signed up with</li>
            <li>Include "Account Deletion Request" in the subject line</li>
            <li>I'll process your request within 24-48 hours</li>
          </ol>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">What Gets Deleted</h2>
          <p className="text-muted-foreground leading-relaxed mb-3">
            When your account is deleted, the following data will be permanently removed:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>Your account profile and login credentials</li>
            <li>All API keys associated with your account</li>
            <li>Job history and compression logs</li>
            <li>Any unused credits in your account</li>
            <li>All personal information and preferences</li>
          </ul>
        </div>
        
        <div className="bg-danger-soft border border-danger-border rounded-lg p-4">
          <h3 className="text-lg font-medium text-danger mb-2">⚠️ Important Notice</h3>
          <p className="text-muted-foreground">
            <strong>Account deletion is permanent and cannot be undone.</strong> Make sure to download any important data 
            or cancel any active subscriptions before requesting deletion.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Alternative: Temporary Deactivation</h2>
          <p className="text-muted-foreground leading-relaxed">
            If you're not sure about permanent deletion, you can also request temporary account deactivation. 
            This will disable your account while preserving your data for potential reactivation later. 
            Contact me at the same email address to discuss this option.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Need Help?</h2>
          <p className="text-muted-foreground leading-relaxed">
            If you have questions about account deletion or need assistance with the process, 
            feel free to reach out to <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a>.
            {' '}I'm here to help make the process as smooth as possible.
          </p>
        </div>
      </div>
    </div>
  )
}; 